import React from "react";
import { Field, useFormikContext } from "formik";
import { Form, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function ProjectProfile({ validation }) {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext();

  const projectAimOptions = [
    "old_tree_monitoring",
    "irrigation_optimization_young_trees",
    "technology_validation",
    "smart_city",
    "partnership_project",
    "irrigation_optimization",
    "mistletoe_control",
    "groundwater_lowering_monitoring",
    "general_drought_stress_monitoring",
    "irrigation_demand_determination",
  ];

  return (
    <div className="w-100">
      <Row>
        <Col lg={12} className="mb-3">
          <Form.Group>
            <Form.Label>{t("project.name")} *</Form.Label>
            <Field className="form-control" name="name" validate={validation.nameValidation} />
          </Form.Group>
        </Col>

        <Col lg={12} className="mb-3">
          <Form.Group>
            <Form.Label>{t("project.aim")}</Form.Label>
            <Field as="select" className="form-select" name="aim">
              <option value="">{t("project.select_aim")}</option>
              {projectAimOptions.map((option) => (
                <option key={option} value={option}>
                  {t(`project.aim_${option}`)}
                </option>
              ))}
            </Field>
          </Form.Group>
        </Col>

        <Col lg={12} className="mb-3">
          <Form.Group>
            <Form.Label>{t("project.description")}</Form.Label>
            <Field
              as="textarea"
              className="form-control"
              name="description"
              rows={3}
              placeholder={t("project.description_placeholder")}
            />
          </Form.Group>
        </Col>

        <Col lg={12} className="mb-3">
          <Form.Group>
            <Form.Label>{t("project.research_question")}</Form.Label>
            <Field
              as="textarea"
              className="form-control"
              name="research_question"
              rows={3}
              placeholder={t("project.research_question_placeholder")}
            />
          </Form.Group>
        </Col>

        <Col lg={12} className="mb-3">
          <Form.Group>
            <Form.Label>{t("project.methodology")}</Form.Label>
            <Field
              as="textarea"
              className="form-control"
              name="methodology"
              rows={4}
              placeholder={t("project.methodology_placeholder")}
            />
          </Form.Group>
        </Col>

        <Col lg={12} className="mb-3">
          <Form.Group>
            <Form.Label>{t("project.results")}</Form.Label>
            <Field
              as="textarea"
              className="form-control"
              name="results"
              rows={3}
              placeholder={t("project.results_placeholder")}
            />
          </Form.Group>
        </Col>

        <Col lg={12} className="mb-3">
          <Form.Group>
            <Form.Label>{t("project.challenges")}</Form.Label>
            <Field
              as="textarea"
              className="form-control"
              name="challenges"
              rows={3}
              placeholder={t("project.challenges_placeholder")}
            />
          </Form.Group>
        </Col>

        <Col lg={12} className="mb-3">
          <Form.Group>
            <Form.Label>{t("project.materials")}</Form.Label>
            <Form.Control
              type="file"
              multiple
              onChange={(event) => {
                const files = Array.from(event.currentTarget.files || []);
                setFieldValue("materialsFiles", files);
              }}
            />
            {values?.materialsFiles?.length ? (
              <div className="text-muted mt-2" style={{ fontSize: "12px" }}>
                {values.materialsFiles.length} {t("files_selected")}
              </div>
            ) : null}
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
}

export default ProjectProfile;
